import { UseFormReturn, SubmitHandler } from 'react-hook-form';

import { PageLoader } from 'components/PageLoader';
import { EmptyState } from 'components/EmptyState';

import { ReviewForm } from './ui/form';
import { ShareModal } from './ui/share-modal';
import { SuccessScreen } from './ui/success';
import * as styled from './styles';

type Props = {
  form: UseFormReturn<Review.ReviewFormValues>;
  onSubmit: SubmitHandler<Review.ReviewFormValues>;
  formData: Kudable.ReviewFormData | null;
  error: string | null;
  submitted: boolean;
  overallRating: number;
  categoryRatings: Record<string, number>;
  isUploading: boolean;
  uploadError: string | null;
  uploadedAssets: Review.UploadedReviewAsset[];
  maxMedia: number;
  onCategoryChange: (category: string, rating: number) => void;
  onAddMedia: (file: File) => void;
  onRemoveMedia: (id: string) => void;
  participantRatings: Record<string, number>;
  participantComments: Record<string, string>;
  onParticipantRatingChange: (memberId: string, rating: number) => void;
  onParticipantCommentChange: (memberId: string, value: string) => void;
  shareModalState: Review.ShareModalState | null;
  onShareModalClose: () => void;
};

export const ReviewScene = ({
  form,
  onSubmit,
  formData,
  error,
  submitted,
  shareModalState,
  onShareModalClose,
  ...rest
}: Props) => {
  const shareModal = shareModalState ? (
    <ShareModal
      providerName={shareModalState.providerName}
      profileUrl={shareModalState.profileUrl}
      onClose={onShareModalClose}
    />
  ) : null;

  if (submitted) {
    const reviewerName = form.getValues('reviewer_name');
    return (
      <>
        <SuccessScreen reviewerName={reviewerName} />
        {shareModal}
      </>
    );
  }
  if (error)
    return (
      <EmptyState
        fullPage
        icon="⚠️"
        title="Something went wrong"
        body={error}
      />
    );
  if (!formData) return <PageLoader fullPage />;

  return (
    <div>
      <styled.TopBar>
        <styled.Logo>Kudable</styled.Logo>
      </styled.TopBar>
      <styled.Container>
        <styled.Card>
          <ReviewForm
            form={form}
            onSubmit={onSubmit}
            formData={formData}
            {...rest}
          />
        </styled.Card>
      </styled.Container>
      {shareModal}
    </div>
  );
};
